import React from 'react';

const Experience = () => {
  return (
    <div
      name="experience"
      className="bg-gradient-to-b from-gray-800 to-gray-800 w-full text-white"
    >
      <div className="max-w-screen-lg px-4 pt-12 mx-auto flex flex-col justify-center w-full h-full">
        <div className="pb-8">
          <p className="text-4xl font-bold inline border-b-4 border-gray-500">
            Experience
          </p>
        </div>
        <h5 className="text-xl mt-6">
          - Full Stack Engineer at <span className="text-red-400">Simplia</span>
          <span className="text-base ml-1 text-gray-400">
            (Jan 2024 - Present)
          </span>
        </h5>
        <p className="text-xl mt-5"></p>
        <br />
        <ul className="text-lg list-disc list-inside">
          <li>
            Developed and maintained full-stack web applications using
            JavaScript, React, and Node.js to streamline client services.
          </li>
          <li>
            Led the integration of third-party APIs and optimized data workflows
            to enhance system performance and reliability.
          </li>
          <li>
            Implemented user authentication and session management using
            Passport.js, including Google OAuth integration.
          </li>
          <li>
            Collaborated closely with cross-functional teams to deliver scalable
            solutions and improve development processes.
          </li>
          <li>
            Enhanced user experience by building responsive, user-friendly UI
            components using React and LitElement.
          </li>
          <li>
            Spearheaded the design and implementation of reusable components,
            improving code maintainability and accelerating development cycles.
          </li>
        </ul>
        <h5 className="text-xl mt-6">
          - Software Engineer Trainee at{' '}
          <span className="text-orange-300">Parentof Solutions</span>
          <span className="text-base ml-1 text-gray-400">
            (Dec 2022 - Aug 2023)
          </span>
        </h5>
        <p className="text-xl mt-5"></p>
        <br />
        <ul className="text-lg list-disc list-inside">
          <li>
            Orchestrated a robust backend system utilizing MongoDB, GraphQL API,
            NodeJS, ExpressJS, and Redis.
          </li>
          <li>
            Designed a meticulous backend infrastructure for efficient data
            storage, retrieval, and seamless communication between application
            components.
          </li>
          <li>
            Developed a user-friendly frontend with ReactJS and NextJS for an
            engaging user interface.
          </li>
          <li>
            Ensured smooth interaction between the frontend and backend,
            delivering a responsive user experience.
          </li>
          <li>
            Integrated Strapi CMS to streamline content management, simplifying
            the creation, editing, and management of content.
          </li>
          <li>
            Empowered the team to control and update information presented to
            users.
          </li>
          <li>
            Achieved a harmonious blend of technologies on both the backend and
            frontend for a dynamic and user-friendly platform.
          </li>
          <li>
            Successfully met organization goals and exceeded user expectations.
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Experience;
